import * as React from "react";
import { DashboardFilterLightbox } from "./DashboardFilterLightbox";
import { BaseComponent } from "../../../../../../react-core/Html/BaseComponent";
import { SavedFiltersDropdown } from "./SavedFiltersDropdown";
import { DashboardFilters } from "./DashboardFilters";
import { DashboardTab } from "../../Resource/Content";
import { DeleteLightbox } from "../../../../Common/DeleteLightbox";
import { ClientDashboardFiltersModel } from "../../../../../../Wrap/Models/Domains/Users/DashboardFilter/ClientDashboardFiltersModel";
import { ClientNotificationFiltersModel } from "../../../../../../Wrap/Models/Domains/Users/NotificationFilter/ClientNotificationFiltersModel";

interface IDashboardSummaryTilesProps {
    currentTabIndex: DashboardTab;
    data: any[];
    onAdd: (changes: ClientDashboardFiltersModel | ClientNotificationFiltersModel) => void;
    onSave: (changes: ClientDashboardFiltersModel | ClientNotificationFiltersModel) => void;
    onDelete: (id: number) => void;
    onReOrder: (newList: ClientDashboardFiltersModel[] | ClientNotificationFiltersModel[]) => void;
    pressedId: number;
}

interface IDashboardSummaryTilesState {
    showLightbox: boolean;
    showDeletelightbox: boolean;
    filterId?: number;
}

export class DashboardSummaryTiles extends BaseComponent<IDashboardSummaryTilesProps, IDashboardSummaryTilesState> {
    constructor(props: IDashboardSummaryTilesProps) {
        super(props);
        this.state = {
            showLightbox: false,
            showDeletelightbox: false,
            filterId: null,
        };
    }

    public setDeletelightbox = (value: boolean) => {
        this.setState({ showDeletelightbox: value });
    };

    public render(): JSX.Element {
        return (
            <>
                <div className="row narrow-gutter pb-32">
                    {this.props.data &&
                        this.props.data?.slice(0, 3)?.map((ele, i) => {
                            return (
                                <DashboardFilters
                                    key={`${i}-${ele?.FilterId}`}
                                    data={ele}
                                    pressedId={this.props.pressedId}
                                    onEdit={(filterId) => {
                                        this.setState({ showLightbox: true, filterId: filterId });
                                    }}
                                    tab={this.props.currentTabIndex}
                                />
                            );
                        })}
                    <div className="col-12 col-xs-6 col-md-auto col-equalise">
                        <SavedFiltersDropdown
                            data={this.props.data}
                            onDelete={(id) => this.setState({ showDeletelightbox: true, filterId: id })}
                            onEdit={(filterId) => {
                                this.setState({ showLightbox: true, filterId: filterId });
                            }}
                            onReorder={(newList) => this.props.onReOrder(newList)}
                            currentTabIndex={this.props.currentTabIndex}
                        />
                    </div>
                    <div className="col-6 col-max-245 col-lg-fluid col-equalise">
                        <button
                            className="new-summary-tile ad d4"
                            onClick={() => {
                                this.setState({ showLightbox: true, filterId: null });
                            }}
                        >
                            <span className="icon" aria-hidden="true"></span>
                            <span className="text">Create filter</span>
                        </button>

                        {this.state.showLightbox && (
                            <DashboardFilterLightbox
                                dashBoardFilterCount={this.props.data?.length}
                                onCancel={() => {
                                    this.setState({ showLightbox: false });
                                }}
                                setDeletelightbox={(value) => this.setDeletelightbox(value)}
                                FilterId={this.state.filterId}
                                onDelete={(id) => this.props.onDelete(id)}
                                onAdd={(data) => this.props.onAdd(data)}
                                onSave={(data) => this.props.onSave(data)}
                                currentTabIndex={this.props.currentTabIndex}
                            />
                        )}

                        {this.state.showDeletelightbox && (
                            <DeleteLightbox
                                onClose={() => this.setState({ showLightbox: false, showDeletelightbox: false })}
                                onDelete={() => {
                                    this.setState({ showLightbox: false, showDeletelightbox: false });
                                    this.props.onDelete(this.state.filterId);
                                }}
                                content={<p>Are you sure you want to delete this activity?</p>}
                            />
                        )}
                    </div>
                </div>
            </>
        );
    }
}
